var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8408 1.66666L31.8408 6.66666M31.8408 6.66666L26.8408 11.6667M31.8408 6.66666H8.50749C4.82559 6.66666 1.84082 9.65143 1.84082 13.3333M6.84082 28.3333L1.84082 23.3333M1.84082 23.3333L6.84082 18.3333M1.84082 23.3333H25.1742C28.856 23.3333 31.8408 20.3485 31.8408 16.6667",
    stroke: "#323133",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.46a81d2f2de105142a04027fa915a1e4.svg";
export { ForwardRef as ReactComponent };